var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMapNavigation = function SvgMapNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 0C2.111 0 .25 1.712.25 4.154c0 .871.212 1.477.605 2.149l3.242 5.538a.325.325 0 0 0 .555 0l3.243-5.538c.393-.672.605-1.278.605-2.15C8.5 1.713 6.639 0 4.375 0Zm0 2.154c1.051 0 1.904.826 1.904 1.846s-.853 1.846-1.904 1.846S2.471 5.02 2.471 4s.853-1.846 1.904-1.846Z",
    fill: "currentColor"
  })));
};

export default SvgMapNavigation;